import { render, staticRenderFns } from "./BIParameterRulesTab.vue?vue&type=template&id=104250b2&"
import script from "./BIParameterRulesTab.vue?vue&type=script&lang=js&"
export * from "./BIParameterRulesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports